import { render, staticRenderFns } from "./empty-years.vue?vue&type=template&id=505b329c&scoped=true&lang=pug&"
import script from "./empty-years.vue?vue&type=script&lang=js&"
export * from "./empty-years.vue?vue&type=script&lang=js&"
import style0 from "./empty-years.vue?vue&type=style&index=0&id=505b329c&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "505b329c",
  null
  
)

component.options.__file = "empty-years.vue"
export default component.exports